import React from 'react';
import FontAwesomeIcon from '@fortawesome/react-fontawesome'
import {faUser} from '@fortawesome/fontawesome-free-solid'

import './NavBar.css'

const NavBar = (props) =>
  <div className="navbar">
    <div className="left">
      <img className="logo" src={props.globalState.theme.logo} alt="Logo" />
    </div>
    <div className="right">
      <input
          type="text"
          className="search-bar"
          placeholder="Search"
          onChange={(e) => props.actions.textSearch(e.target.value)}
          value={props.globalState.textFilter}
        />
        {
          props.globalState.user.photoURL
            ? <img className="profile-pic" src={props.globalState.user.photoURL} alt="Sign out and profile menu will go here." />
          : <div className="profile-pic-missing"><FontAwesomeIcon icon={faUser} style={{color: 'grey'}} alt="Sign out and profile menu will go here." /></div>
        }
    </div>
  </div>

export default NavBar;



// WEBPACK FOOTER //
// ./src/components/NavBar.js